import React, { useCallback, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import * as Yup from "yup";
import {
  InputType,
  handleApiErrors,
  validationRegex,
} from "../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ClassService from "../../Services/ClassService";
import DataProvider from "../../Utils/DataProvider";
import SubjectService from "../../Services/SubjectService";
import Image from "../../Components/Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import { ImageFilters } from "../../Utils/Enums";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import MockTestService from "../../Services/MockTestService";
import QuestionBankService from "../../Services/QuestionBankService";

const AddMockTest = () => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  // const [questionData, setQuestionData] = useState([]);
  const [resetSubject, setResetSubject] = useState(false);
  const [resetMedium, setResetMedium] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [question, setQuestion] = useState({ ...useLocation().state });
  const [isEdit, setIsEdit] = useState({ ...useLocation().state });
  const [additionalInputs, setAdditionalInputs] = useState([
    { name: "subjects0", value: "noOfQuestions0" },
  ]);
  const [deleteInput, setDeleteInput] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [negativeMarking, setNegativeMarking] = useState(isEdit.negativeMarking==="No" ? false : true);
  const [stepOneValidations, setStepOneValidations] = useState(
    Yup.object().shape({
      mocktest: validationRegex.required,
      subjects0: validationRegex.required,
      class_id: validationRegex.required,
      medium: validationRegex.required,
      noOfQuestions0: validationRegex.required,
      duration: validationRegex.required,
     
    })
  );

  const defaultValues = {
    mocktest: isEdit ? isEdit.mockTestName : "",
    class_id: isEdit ? isEdit.class_id : "",
    medium: isEdit ? isEdit.medium : "",
    duration: isEdit ? isEdit.durationInMinutes : "",
    negativeMarking: isEdit ? isEdit.negativeMarking   : false,
  }

  const navigate = useNavigate();

  const {
    register: registerStepOne,
    handleSubmit: handleSubmitStepOne,
    setValue: setValuesStepOne,
    formState: { errors: errorsStepOne, },
    watch: watchStepOne,
    getValues: getValuesStepOne,
    reset: resetStepOne,
  } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: defaultValues,
  });

  const saveStepOneData = async (data) => {
    const { mocktest, class_id, medium, duration } = data;
    let subjectData = [];
    additionalInputs.forEach((item) => {
      subjectData.push({
        "subject": getValuesStepOne(item.name),
        "numberOfQuestions": getValuesStepOne(item.value)
      });
    });


    try {
      // Fetch all subjects to get the question count
      const response1 = await SubjectService.getAllSubjectsWithoutPagination(class_id);
      if (!response1 || !Array.isArray(response1.data)) {
        throw new Error("Failed to fetch subjects.");
      }

      // Create a map of subject ID to questionCount
      const subjectCounts = response1.data.reduce((acc, subject) => {
        acc[subject._id] = subject.questionCount; // Map subject ID to question count
        return acc;
      }, {});

      // Validate number of attempts for each subject
      for (const item of subjectData) {
        const questionCount = subjectCounts[item.subject];
        if (questionCount === undefined) {
          toast.error(`Subject not found.`);
          return;
        }
        if (parseInt(item.numberOfQuestions, 10) > questionCount) {
          toast.error(`The number of attempts for subject exceeds available questions.`);
          return;
        }
        if (parseInt(item.numberOfQuestions) < 0) {
          toast.error(`Invalid number of attempts for subject.`);
          return;
        }
        if (parseInt(duration) < 0) {
          toast.error(`Invalid Duration.`);
          return;
        }
      }

      // Proceed with saving mock test
      const response = await MockTestService.addMockTest(
        isEdit?._id || "",
        mocktest,
        class_id,
        medium,
        subjectData,
        duration,
         negativeMarking === true ? "Yes" : "No"
        
      );
      toast.success(response.message);
      setIsEdit({});
      navigate(RoutesPath.viewMockTest);

    } catch (error) {
      handleApiErrors(error);
    }
  };



  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllSubjects = async (classId) => {
    try {
      const response = await SubjectService.getAllSubjectsWithoutPagination(
        classId
      );

      setSubjects(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };


  // useEffect(() => {
  //   const timeOutId = setTimeout(() => {
  //     setOffset(0);
  //     if (searchQuery != null) {
  //       fetchData();
  //     }
  //   }, 500);
  //   return () => clearTimeout(timeOutId);
  // }, [searchQuery]);
  // const getAllQuestions = async () => {
  //   try {
  //     const response = await QuestionBankService.getAllQuestions(offset, limit, searchQuery || "",
  //       selectedClass || "",
  //       selectedSubject || "",
  //       selectedMedium || ""
  //     );
  //     setQuestionData(response.data);
  //     console.log(questionData, 'asdf');
  //     setAvailableDataCount(response.availableDataCount);

  //     if (offset !== 0 && (offset * limit) > (availableDataCount - 1)) {
  //       setOffset(offset - 1)
  //     }
  //   } catch (error) {
  //     handleApiErrors(error);
  //   }
  // };
  useEffect(() => {
    if (selectedClass) {
      getAllSubjects(selectedClass);
    } else {
      setSubjects([]);
    }
  }, [selectedClass]);
  // useEffect(() => {
  //   getAllQuestions();
  // }, [offset, selectedClass, selectedMedium, selectedSubject]);
  const importantStyle = {
    marginBottom: "0px !important",
  };

  useEffect(() => {
    getAllClasses();
    if (isEdit && isEdit.subjectData) {
      const subjectInputs = []
      isEdit.subjectData.forEach((data, index) => {
        addValidation(`subjects${index}`, validationRegex.required)
        addValidation(`noOfQuestions${index}`, validationRegex.required)
        subjectInputs.push({ name: `subjects${index}`, value: `noOfQuestions${index}` });
        setValuesStepOne(`noOfQuestions${index}`, data?.numberOfQuestions)
        setValuesStepOne(`subjects${index}`, data?.subject?._id)
      })
      setAdditionalInputs(subjectInputs)
    }
  }, []);

  useEffect(() => {
    if (getValuesStepOne("class_id")) {
      if (!isFirstLoad) {
        additionalInputs.forEach((input) => {
          setValuesStepOne(input.name, "");
        })

        setResetSubject(true);
        setSubjects([]);
      } else {
        setTimeout(() => setIsFirstLoad(false), 1000);
      }
      getAllSubjects(getValuesStepOne("class_id"));
    }
  }, [watchStepOne("class_id")]);

  // Handler to add validation dynamically
  const addValidation = useCallback((fieldName, validationSchema) => {
    setStepOneValidations((prevSchema) => prevSchema.shape({ [fieldName]: validationSchema }));
  }, []);

  // Handler to remove validation dynamically
  const removeValidation = useCallback((fieldName) => {
    setStepOneValidations((prevSchema) => {
      const { [fieldName]: _, ...rest } = prevSchema.fields; // Remove the specific field
      return Yup.object().shape(rest);
    });
  }, []);

  // const handleAddMore = () => {
  //   addValidation(`subjects${additionalInputs.length}`, validationRegex.required)
  //   addValidation(`noOfQuestions${additionalInputs.length}`, validationRegex.required)
  //   setAdditionalInputs([...additionalInputs, { name: `subjects${additionalInputs.length}`, value: `noOfQuestions${additionalInputs.length}` }]);
  //   setDeleteInput(true);
  // };

  // const handleDelete = (index) => {
  //   const newInputs = [...additionalInputs];
  //   newInputs.splice(index, 1);
  //   removeValidation(additionalInputs[index].name)
  //   removeValidation(additionalInputs[index].value)
  //   setAdditionalInputs(newInputs);
  //   if (newInputs.length === 1) {
  //     setDeleteInput(false);
  //   }
  // };
  const handleAddMore = () => {
    const newIndex = additionalInputs.length;
    addValidation(`subjects${newIndex}`, validationRegex.required);
    addValidation(`noOfQuestions${newIndex}`, validationRegex.required);
    // Add a new input field with a unique index
    setAdditionalInputs([
      ...additionalInputs,
      { name: `subjects${newIndex}`, value: `noOfQuestions${newIndex}` }
    ]);
    // Reset the mock test dropdown and attempts field for the new entry
    setValuesStepOne(`subjects${newIndex}`, "");
    setValuesStepOne(`noOfQuestions${newIndex}`, "");
    setDeleteInput(true);
  };

  const handleDelete = (index) => {
    // Remove the validation for the field being deleted
    removeValidation(additionalInputs[index].name);
    removeValidation(additionalInputs[index].value);
    // Remove the input field
    const newInputs = [...additionalInputs];
    newInputs.splice(index, 1);
    // Update the state with the remaining input fields
    setAdditionalInputs(newInputs);
    // Reset the delete input button state
    if (newInputs.length === 1) {
      setDeleteInput(false);
    }
  };
  return (
    <div className="content" data-number="1">
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">MOCK TEST</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Mock Test</h4>
        </div>
      </div>

      <div className="table_container ">
        <div className="table_title p-0 mb-4">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {isEdit._id ? "Update" : "Create"} Mock Test
            </h1>
          </div>
        </div>

        <form className="" onSubmit={handleSubmitStepOne(saveStepOneData)}>
          <div className="row profile_inputs w-100">
            <div className="col-md-6">
              <CustomTextField
                labelTitle="Mock Test Name"
                placeholder="Enter Mock Test"
                name="mocktest"
                id="mocktest"
                showError={errorsStepOne?.mocktest}
                errorMessage={errorsStepOne?.mocktest?.message}
                register={registerStepOne}
                additionalClasses="profile_edit"
                showMandatory={true}
              />
            </div>
            <div className="col-md-6">
              <CustomDropDown
                labelTitle="Select Medium"
                placeholder="Select"
                name="medium"
                id="medium"
                additionalClasses="profile_edit"
                setResetValue={setResetMedium}
                resetValue={resetMedium}
                inputType={InputType.text}
                showError={errorsStepOne?.medium}
                errorMessage={errorsStepOne?.medium?.message}
                showMandatory={true}
                setValue={setValuesStepOne}
                options={DataProvider.mediumList}
                defaultOption={() => {
                  return question.medium
                    ? { value: question.medium, label: question.medium }
                    : null;
                }}
              />
            </div>
            <div className="col-md-6">
              {classes && classes.length != 0 && (
                <CustomDropDown
                  labelTitle="Select Class"
                  placeholder="Select"
                  name="class_id"
                  id="class_id"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showError={errorsStepOne?.class_id}
                  errorMessage={errorsStepOne?.class_id?.message}
                  showMandatory={true}
                  setValue={setValuesStepOne}
                  options={classes?.map((e) => {
                    return { value: e._id, label: e.class_name };
                  })}
                  defaultOption={() => {
                    if (isEdit?.class_id && classes) {
                      const matchingClass = classes.find(
                        (value) => value._id === isEdit.class_id
                      );
                      if (matchingClass) {
                        return {
                          value: matchingClass._id,
                          label: matchingClass.class_name,
                        };
                      }
                    }
                    return null;
                  }}
                />
              )}
            </div>

            <div className="col-md-6">
              <CustomTextField
                labelTitle="Duration in Mins"
                placeholder="Enter Duration in Mins"
                name="duration"
                id="duration"
                inputType={InputType.number}
                showError={errorsStepOne?.duration}
                errorMessage={errorsStepOne?.duration?.message}
                register={registerStepOne}
                additionalClasses="profile_edit"
                showMandatory={true}
              />
            </div>
            <div className="col-md-6 d-flex flex-column gap-2  my-2 gap-3 ">

              <h3 className="fw-500 fs-14  mb-0">Enable Negative Marking <span className="text-danger">*</span></h3>
              <label
                className="switch"
              >
                <input
                  type="checkbox"
                  checked={negativeMarking}
                  onChange={() =>{ setNegativeMarking(!negativeMarking)}}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="col-md-12">
              <div className="Highlightedsections px-3 py-4 m-0">
                {additionalInputs.map((value, index) => (
                  <div key={index} className="row m-0 p-0">
                    <div className="col-md-6">
                      <CustomDropDown
                        labelTitle="Select Subject"
                        placeholder="Select"
                        name={value.name}
                        id={value.name}
                        additionalClasses="profile_edit"
                        resetValue={resetSubject}
                        setResetValue={setResetSubject}
                        inputType={InputType.text}
                        showError={errorsStepOne[value.name]}
                        errorMessage={errorsStepOne[value.name]?.message}
                        register={registerStepOne}
                        showMandatory={true}
                        setValue={setValuesStepOne}
                        labelClass="customtextcolorlabel"
                        options={subjects?.filter((e) => additionalInputs.findIndex((data) => getValuesStepOne(data.name) === e._id) === -1)
                          .map((e) => {
                            return { value: e._id, label: e.subject_name };
                          })}
                        defaultOption={() => {
                          const subject = isEdit?.subjectData && (isEdit.subjectData.length >= index - 1) ? isEdit?.subjectData[index]?.subject : null;
                          return isEdit ? { value: subject?._id, label: subject?.subject_name ? subject?.subject_name : "Select Subject" } : null
                        }}
                      />
                    </div>

                    <div className="col-md-6">
                      <CustomTextField
                        labelTitle="Total No of Questions"
                        placeholder="Total No of Questions"
                        name={value.value}
                        id={value.value}
                        inputType={InputType.number}
                        showError={errorsStepOne[value.value]}
                        errorMessage={errorsStepOne[value.value]?.message}
                        register={registerStepOne}
                        additionalClasses="profile_edit"
                        labelClass="customtextcolorlabel"
                        showMandatory={true}
                      />
                    </div>
                  </div>
                ))}
                <div className="d-flex justify-content-between px-3 align-items-center">
                  <div
                    className="d-flex align-items-center gap-2 profile"
                    onClick={handleAddMore}
                  >
                    <Image src={SvgImages.addbutton} />
                    <h3 className="add_more mb-0 ">Add More</h3>
                  </div>

                  {(deleteInput || isEdit) && additionalInputs.length > 1 && (
                    <div
                      className="d-flex align-items-center gap-2 text-danger  profile"
                      onClick={() => handleDelete(additionalInputs.length - 1)}
                    >
                      <Image
                        src={SvgImages.deleteIcon}
                        style={ImageFilters.red}
                        alt="Delete Icon"
                      />
                      <h3 className="fw-500 fs-14 mb-0 ">Delete</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-5">
            <ButtonWithIcon
              text={isEdit._id ? "Update" : "Submit"}
              icon={SvgImages.tick_mark}
              onClick={handleSubmitStepOne(saveStepOneData)}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMockTest;
